import {createAction} from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  GET, EXAM
} from "../../constants";
import {IMenuItems} from "../../../types";

export const getExamAction = createAction<any>(GET + EXAM + FETCH);
export const getExamActionDone = createAction<any>(GET + EXAM + FETCH + DONE);
export const getExamActionFail = createAction<undefined>(GET + EXAM + FETCH + FAIL);

